import { render, staticRenderFns } from "./DepartmentButtonSelectorDialog.vue?vue&type=template&id=a65480ca&scoped=true&"
import script from "./DepartmentButtonSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./DepartmentButtonSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentButtonSelectorDialog.vue?vue&type=style&index=0&id=a65480ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65480ca",
  null
  
)

export default component.exports